import { useTranslation } from "react-i18next";
import React, { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { deleteProperty } from 'store/slices/personalSlice';
import { useDispatch } from 'react-redux';

const DeleteProperty = ({
  value,
  propertyMeta
}) => {
  const {
    t
  } = useTranslation();
  const [modal, setModal] = useState(false);
  const dispatch = useDispatch();

  const toggle = () => setModal(!modal);

  const handleDelete = () => {
    console.log('DeleteProperty: Attempting to delete', {
      objectId: value.objectId,
      propertyName: propertyMeta.name
    });

    try {
      // Dispatch the delete action
      dispatch(deleteProperty(value.objectId));
      console.log('DeleteProperty: Delete action dispatched');
      setModal(false);
    } catch (error) {
      console.error('DeleteProperty: Failed to delete property', error);
      alert('Failed to delete property: ' + error.message);
    }
  };

  return <>
      <Button color='link' onClick={toggle} className='text-danger'>
        <span role="img" aria-label="wastebasket">🗑️</span>
      </Button>

      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>{t("Delete Property")}</ModalHeader>
        <ModalBody>{t("Are you sure you want to delete this")}{propertyMeta.showName.toLowerCase()}?
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>{t("Cancel")}</Button>
          <Button color="danger" onClick={handleDelete}>{t("Delete")}</Button>
        </ModalFooter>
      </Modal>
    </>;
};

export default DeleteProperty;